import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=04b038aa&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b038aa')) {
      api.createRecord('04b038aa', component.options)
    } else {
      api.reload('04b038aa', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=04b038aa&", function () {
      api.rerender('04b038aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JdO0dcqRaHBS/JS/comp/IncreaseNumber.vue"
export default component.exports